import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';
import { Link } from 'react-router-dom';
import React, { useRef } from "react";

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import $ from 'jquery';
export default function CollegeUserSeatMapping() {

  const [sectionUserTypesData, setSectionUserTypesData] = useState([]);
  const [selectedUserType, setSelectedUserType] = useState(null);
  const [selectedUserSeatLevelId, setSelectedUserSeatLevel] = useState([]);
  const [userSeatLevelData, setUserSeatLevelData] = useState([]);
  const [userSeatLevelId, setUserSeatLevel] = useState([]);
  const [userSeatCd, setUserSeatCd] = useState(null);
  const [userSeatCode, setUserSeatCode] = useState([]);
  const [usersListData, setUsersListData] = useState([]);
  const [userNameId, setUserNameId] = useState([]);
  const [userNames, setUserNames] = useState(null);
  const [usersDataListInSeat, setUsersDataListInSeat] = useState([]);
  const [isFirstSubmit, setFirstSubmit] = useState(false);

  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [deleteid, setDeleteid] = useState(false);
  const [isDelete, setDelete] = useState(false);
  const [isRelieve, setRelieve] = useState(false);
  const [deleteUserId, setDeleteUserId] = useState([]);
  const [deleteName, setDeleteName] = useState([]);

  {/*------------Data Table--------------*/ }
  const [searchTerm, setSearchTerm] = useState("");
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;
  const tableRef = useRef(null);
  const dataTableRef = useRef(null);

  {/*------------------------------------*/ }

  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/admin/");
  }

  const getSectionUserTypes = async () => {
    http.get('/Admin/getSectionUserTypes')
      .then((response) => {
        setSectionUserTypesData(response.data.result);
      }).catch((error) => {
        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {
          toast.error(message);
        } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/admin/"), 5000);
        } else {
          toast.error(message);
        }
      });
  };

  useEffect(() => {
    getSectionUserTypes();
  }, []);


  const handleUserTypeChange = (selectedOption) => {
    setSelectedUserType(selectedOption); // Store the selected option
    setSelectedUserSeatLevel(selectedOption.seat_level); // Store the selected option
    setUserSeatLevel([]); // Clear the Seat Name selection
    setUserSeatCd([]);  // Clear the Seat Code
    setUserNames([]);
    //getUserDataListInSeat();
  };

  useEffect(() => {
    const UserSeatLevel = () => {
      http
        .get('/Admin/getUserSeatLevel', {
          params: {
            seat_level: selectedUserSeatLevelId, // Ensure `selectedUserSeatLevel` is defined in your component state or props
          },
        })
        .then((response) => {
          setUserSeatLevelData(response.data.result); // Update the state with the response data
        })
        .catch((error) => {
          const status = error.response?.data?.http_status;
          const message = error.response?.data?.message || "An error occurred";

          if (status === 500 || error.response?.data?.status_code === "ERR5") {
            setUserSeatLevelData([]);
            toast.error("No seat names were found");
          } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/admin/"), 5000);
          } else {
            toast.error(message);
          }
        });
    };

    const usersData = () => {
      http.get('/Admin/getUserDataForSeat', {
        params: {
          seat_level: selectedUserSeatLevelId
        },
      }).then((response) => {
        setUsersListData(response.data.result);
      }).catch((error) => {
        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {
          setUsersListData([]);
          toast.error("No users found");
        } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/admin/"), 5000);
        } else {
          toast.error(message);
        }
      });
    };

    if (selectedUserSeatLevelId != '') {
      UserSeatLevel();
      usersData();

    }
  }, [selectedUserSeatLevelId]);

  const handleSeatNameChange = (selectedOption) => {
    setUserSeatCd(selectedOption);
    setUserSeatLevel(selectedOption.seat_level);
    setUserSeatCode(selectedOption.seat_code);
    setUserNames([]);
  }

  const getUserDataListInSeat = () => {
    const IDD = selectedUserSeatLevelId;
    // console.log("IDD", IDD);
    http
      .get('/Admin/getUserDataListInSeat', {
        params: {
          seat_level: IDD,
        },
      })
      .then((response) => {
        //console.log("response=", response.data.result);
        setUsersDataListInSeat(response.data.result);

      })
      .catch((error) => {

        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {
          setUsersDataListInSeat([]);
          toast.error("Users List Not found");
        } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/admin/"), 5000);
        } else {
          toast.error(message);
        }
      });
  };

  useEffect(() => {

    if (selectedUserSeatLevelId != '') {
      getUserDataListInSeat();

    }

  }, [currentPage, selectedUserSeatLevelId])

  {/* useEffect(() => {
    if (usersDataListInSeat.length > 0) {
     
      setTimeout(() => {
        if (dataTableRef.current) {
          dataTableRef.current.destroy(true);
          dataTableRef.current = null;
        }

        const table = $('#dataTable').DataTable({
          searching: true,
          info: true,
          pageLength: 50,
          autoWidth: false,
          responsive: true,
          columnDefs: [{ targets: "_all", className: "dt-center" }],
        });

        dataTableRef.current = table;
      }, 0); 
    }
  }, [usersDataListInSeat]); */}

  {/*------Data Table------*/ }

  $('#collapseOne').on('shown.bs.collapse', () => {
    setTimeout(() => {
      if (dataTableRef.current) {
        dataTableRef.current.columns.adjust().draw();
      }
    }, 300); // wait a bit after accordion opens
  });

  const filteredUsers = usersDataListInSeat
    .filter((user) =>
      `${user.user_id} ${user.name} ${user.email} ${user.section_name}`.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (!sortColumn) return 0;
      const valA = a[sortColumn];
      const valB = b[sortColumn];
      if (valA < valB) return sortOrder === "asc" ? -1 : 1;
      if (valA > valB) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });

  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  const handleSort = (column) => {
    if (column === sortColumn) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortOrder("asc");
    }
  };
  {/*-----------------------------------*/ }

  const handleUserNameChange = (selectedOption) => {
    setUserNames(selectedOption);
    setUserNameId(selectedOption.value);
  }

  const handlefirstsubmit = () => {

    setFirstSubmit(!isFirstSubmit);

  }
  const handleSubmitData = (e) => {

    e.preventDefault();
    setFirstSubmit(!isFirstSubmit);
    const saveUserDataForSeat = () => {

      const payload = {
        seat_code: userSeatCode,
        user_id: userNameId
      };
      http.post('/Admin/saveUserDataForSeat', payload).then((response) => {
        if (response.data.status_code === 'MSG1') {
          const seatlevel = selectedUserSeatLevelId;
          setSelectedUserSeatLevel([]);
          setUserSeatCd([]);
          setUserNames([]);
          setSelectedUserSeatLevel(seatlevel);
          toast.success('User - Seat Data saved successfully');
        } else {
          toast.error('Failed to save User - Seat Data');
        }
      }).catch((error) => {
        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {
          toast.error(message);
        } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/admin/"), 5000);
        } else {
          toast.error(message);
        }
      });
    };
    saveUserDataForSeat();

  };

  const handleCancel = () => {
    setFirstSubmit(!isFirstSubmit);
    //window.location.reload();
  }

  const cancelForm = () => {
    window.location.reload();
  };
  const handleDelete = (id, user_id, name) => {
    setDeleteid(id);
    setDeleteUserId(user_id);
    setDeleteName(name);
    setDelete(true);
  }

  const handleDeleteSuccess = () => {

    http.delete(`/Admin/deleteUserList`, {
      params: {
        id: deleteid
      }
    }).then((response) => {
      if (response.data.status_code === "MSG3") {
        setDelete(false);
        getSectionUserTypes();
        const seatlevel = selectedUserSeatLevelId;
        setSelectedUserSeatLevel([]);
        setSelectedUserSeatLevel(seatlevel);

        toast.success("User data deleted successfully");
      } else {
        toast.error("Failed to delete user data");
      }
    }).catch((error) => {
      toast.error("Error deleting Usere Data");

    });
  };

  const handleDeleteCancel = () => {
    setDelete(false);
  }

  const handleRelieve = (id, user_id, name) => {
    setDeleteid(id);
    setDeleteUserId(user_id);
    setDeleteName(name);
    setRelieve(true);
  }

  const handleRelieveSuccess = () => {

    http.post(`/Admin/relieveSingleUser`, {
      params: {
        id: deleteid
      }
    }).then((response) => {
      if (response.data.status_code === "MSG32") {
        setRelieve(false);
        getSectionUserTypes();
        const seatlevel = selectedUserSeatLevelId;
        setSelectedUserSeatLevel([]);
        setSelectedUserSeatLevel(seatlevel);

        toast.success("User relieved successfully");
      } else {
        toast.error("Failed to relieve this user");
      }
    }).catch((error) => {
      toast.error("Error occured when relieving user");

    });
  };

  const handleRelieveCancel = () => {
    setRelieve(false);
  }

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '180px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),

    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="table-responsive">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5>College User - Seat Mapping</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div className="card-body">

                        <div className="row justify-content-center">

                          <div className="col-md-12 mb-4">
                            <label className="form-label">
                              User Types<span className="errorclr">*</span>
                            </label>

                            <Select
                              id="usertype"
                              name="usertype"
                              maxMenuHeight={200}
                              menuPlacement="auto"
                              styles={customStyles}
                              className="form-control ht"
                              options={sectionUserTypesData.map(userTypesData => ({
                                value: userTypesData.usertype_id,
                                label: `${userTypesData.user_type_code} - ${userTypesData.user_type_desc}`,
                                type_code: userTypesData.user_type_code,
                                seat_level: userTypesData.seat_level,
                              }))}
                              value={selectedUserType}
                              onChange={handleUserTypeChange}
                            />
                          </div>
                        </div>

                        <div className="pgm-map-box mb-4" style={{ zIndex: '1200' }}>
                          <table className="table colap-table table-hover table-striped">
                            <thead style={{ backgroundColor: "#f8f9fa", color: "#000" }}>
                              <tr style={{ textAlign: "center", verticalAlign: "middle", borderBottom: "2px solid #ddd" }}>
                                <th style={{ textAlign: 'center', verticalAlign: 'middle' }} className="bg-primary" width="50%">Seat Names</th>
                                <th style={{ textAlign: 'center', verticalAlign: 'middle' }} className="bg-primary ">Users</th>

                              </tr>
                            </thead>
                            <tbody>
                              <tr style={{ textAlign: "center", verticalAlign: "middle", borderBottom: "1px solid #ddd" }}>
                                <td>
                                  <Select
                                    id="seat"
                                    name="seat"
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    styles={customStyles}
                                    className="form-control ht"
                                    options={userSeatLevelData.map(SeatLevel => ({
                                      value: SeatLevel.seatCd,
                                      label: `${SeatLevel.seat_name} - ${SeatLevel.seat_desc}`,
                                      seat_level: SeatLevel.seat_level,
                                      seat_code: SeatLevel.seatCd,
                                    }))}
                                    value={userSeatCd}
                                    onChange={handleSeatNameChange}
                                  />
                                </td>
                                <td>
                                  <Select
                                    id="users"
                                    name="users"
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    styles={customStyles}
                                    className="form-control ht"
                                    options={usersListData.map(usersList => ({
                                      value: usersList.user_id,
                                      label: `${usersList.user_id}-${usersList.name}`

                                    }))}
                                    value={userNames}
                                    onChange={handleUserNameChange}
                                  />
                                </td>
                              </tr>

                            </tbody>
                          </table>
                          <div className="col-md-12 txt-aln p-50">

                            <div>
                              <button className="btn btn-primary me-3" type="submit" onClick={handlefirstsubmit}>Submit</button>
                              <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} />
                            </div>

                          </div>

                          <div className="reval-accn">
                            <div className="card height-equal">
                              <div className="card-body dark-timeline">
                                <div className="accordion revaluation-accordion" id="revaluationAccordion">

                                  <div className="accordion-item">
                                    <h2 className="accordion-header" id="subjectOne">
                                      <button
                                        className={`accordion-button txt-primary accordion-light-primary`}
                                        type="button"
                                        onClick={() => setIsAccordionOpen(!isAccordionOpen)} // Toggle accordion state
                                        aria-expanded={isAccordionOpen}
                                        aria-controls="collapseOne"
                                      >
                                        Users List &nbsp;
                                        {isAccordionOpen ? (
                                          <>
                                            <p
                                              style={{
                                                display: "inline",
                                                margin: "0",
                                                color: "#f44336",
                                                fontWeight: "bold",
                                                fontSize: "12px",
                                              }}
                                            >
                                              Hide
                                            </p>
                                            <i className="bi bi-chevron-up" style={{ color: "#f44336" }}></i>
                                          </>
                                        ) : (
                                          <>
                                            <p
                                              style={{
                                                display: "inline",
                                                margin: "0",
                                                color: "#008ce0",
                                                fontWeight: "bold",
                                                fontSize: "12px",
                                              }}
                                            >
                                              Show
                                            </p>
                                            <i className="bi bi-chevron-down" style={{ color: "#008ce0" }}></i>
                                          </>
                                        )}
                                      </button>
                                    </h2>
                                    <div id="collapseOne" className={`accordion-collapse collapse ${isAccordionOpen ? "show" : ""}`} aria-labelledby="subjectOne" data-bs-parent="#revaluationAccordion">
                                      <div className="accordion-body">
                                        <div className="table-responsive">
                                          <div className="d-flex justify-content-between align-items-center mb-3">
                                            {/* Left: Info Text */}
                                            <div>
                                              <small className="text-muted">
                                                Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                                                {Math.min(currentPage * itemsPerPage, filteredUsers.length)} of {filteredUsers.length} items
                                              </small>
                                            </div>
                                            {/* Search Box aligned right */}
                                            <div className="d-flex justify-content-end mb-3">
                                              <input
                                                type="text"
                                                className="form-control"
                                                style={{ width: "250px" }}
                                                placeholder="Search by User ID, Name, Email..."
                                                value={searchTerm}
                                                onChange={(e) => {
                                                  setSearchTerm(e.target.value);
                                                  setCurrentPage(1);
                                                }}
                                              />
                                            </div>
                                          </div>

                                          {/* Table */}
                                          <table className="table table-striped table-strip-bod">
                                            <thead>
                                              <tr>
                                                <th>Sl No</th>
                                                <th onClick={() => handleSort("user_id")}>
                                                  User ID{" "}
                                                  <span style={{ color: "black", cursor: "pointer" }} onClick={() => handleSort("user_id")}>
                                                    {sortColumn === "user_id"
                                                      ? sortOrder === "asc"
                                                        ? "▲"
                                                        : "▼"
                                                      : "▲▼"}
                                                  </span>
                                                </th>

                                                <th onClick={() => handleSort("email")}>
                                                  Email{" "}
                                                  <span style={{ color: "black" ,cursor: "pointer"}}>
                                                    {sortColumn === "email"
                                                      ? sortOrder === "asc"
                                                        ? "▲"
                                                        : "▼"
                                                      : "▲▼"}
                                                  </span>
                                                </th>
                                                <th>Seat Name - Desc</th>
                                                <th>Section Desc</th>
                                                <th>Action</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {paginatedUsers.length > 0 ? (
                                                paginatedUsers.map((userlist, idx) => (
                                                  <tr key={idx}>
                                                    <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                                                    <td>
                                                      <b>{userlist.user_id}</b> <br />
                                                      {userlist.name}
                                                    </td>
                                                    <td>{userlist.email}</td>
                                                    <td>
                                                      {userlist.seat_name} - {userlist.seat_desc}
                                                    </td>
                                                    <td>{userlist.section_name}</td>
                                                    <td>
                                                      <ul className="action">
                                                        <li className="edit">
                                                          <Link
                                                            to="#"
                                                            onClick={() =>
                                                              handleRelieve(userlist.id, userlist.user_id, userlist.name)
                                                            }
                                                          >
                                                            <i className="bi bi-person-dash icn-out-bod" title="Relieve User"></i>
                                                          </Link>
                                                        </li>
                                                        <li className="delete">
                                                          <div
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() =>
                                                              handleDelete(userlist.id, userlist.user_id, userlist.name)
                                                            }
                                                          >
                                                            <i className="bi bi-trash icn-out-bod m-l-5" title="Delete"></i>
                                                          </div>
                                                        </li>
                                                      </ul>
                                                    </td>
                                                  </tr>
                                                ))
                                              ) : (
                                                <tr>
                                                  <td colSpan="6" className="text-center">
                                                    No data found
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>

                                          {/* Pagination */}

                                          <div className="d-flex justify-content-between align-items-center mt-3">
                                            <div>Page {currentPage} of {totalPages}</div>

                                            <div className="d-flex align-items-center">
                                              {/* Prev Button */}
                                              <button
                                                className="btn btn-sm btn-light border me-1"
                                                disabled={currentPage === 1}
                                                onClick={() => setCurrentPage((prev) => prev - 1)}
                                                style={{ width: "32px", height: "32px", padding: "0" }}
                                              >
                                                &lt;
                                              </button>

                                              {/* Page Tabs */}
                                              {[...Array(totalPages)].map((_, index) => {
                                                const pageNum = index + 1;
                                                return (
                                                  <button
                                                    key={pageNum}
                                                    className={`btn btn-sm me-1 border ${pageNum === currentPage ? "btn-primary text-white" : "btn-light"}`}
                                                    onClick={() => setCurrentPage(pageNum)}
                                                    style={{ width: "32px", height: "32px", padding: "0" }}
                                                  >
                                                    {pageNum}
                                                  </button>
                                                );
                                              })}

                                              {/* Next Button */}
                                              <button
                                                className="btn btn-sm btn-light border"
                                                disabled={currentPage === totalPages}
                                                onClick={() => setCurrentPage((prev) => prev + 1)}
                                                style={{ width: "32px", height: "32px", padding: "0" }}
                                              >
                                                &gt;
                                              </button>
                                            </div>
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className={`modal fade show ${isFirstSubmit ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                              <div className="modal-content">
                                <div className="modal-body">
                                  <div className="modal-toggle-wrapper">
                                    <h4 className="text-center pb-2">Are you sure you want to save?</h4>
                                    <div className="d-flex justify-content-center mt-3">
                                      <div>
                                        <button className="btn btn-danger mx-2" onClick={handleSubmitData}>Submit</button>
                                        <button
                                          className="btn"
                                          style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }}
                                          data-bs-dismiss="modal"
                                          onClick={handleCancel}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className={`modal fade show ${isDelete ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                              <div className="modal-content">
                                <div className="modal-body">
                                  <div className="modal-toggle-wrapper">
                                    {/* <ul className="modal-img">
                                    <li> <img src={logo} /></li>
                                </ul> */}
                                    <h4 className="text-center pb-2">Are you sure you want to delete?</h4>
                                    <p className="txt-aln"><b>User ID- {deleteUserId} &nbsp;&nbsp; Name- {deleteName}</b></p>
                                    <p className="text-center">This action cannot be undone. Please confirm if you want to proceed with the deletion.</p>
                                    <div className="d-flex justify-content-center mt-3">
                                      <button className="btn btn-danger mx-2" onClick={() => handleDeleteSuccess()}>Delete</button>
                                      <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleDeleteCancel()}>Cancel</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className={`modal fade show ${isRelieve ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                              <div className="modal-content">
                                <div className="modal-body">
                                  <div className="modal-toggle-wrapper">
                                    {/* <ul className="modal-img">
                                    <li> <img src={logo} /></li>
                                </ul> */}
                                    <h4 className="text-center pb-2">Are you sure you want to Relieve this user?</h4>
                                    <p className="txt-aln"><b>User ID- {deleteUserId} &nbsp;&nbsp; Name- {deleteName}</b></p>
                                    {/* <p className="text-center">This action cannot be undone. Please confirm if you want to proceed with the deletion.</p> */}
                                    <div className="d-flex justify-content-center mt-3">
                                      <button className="btn btn-danger mx-2" onClick={() => handleRelieveSuccess()}>Relieve

                                      </button>
                                      <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleRelieveCancel()}>Cancel</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>




      </Template>
    </>
  );
}
